// ToyCommandAnimationPanel.jsx
import React from 'react';
import PropTypes from 'prop-types';
import ToyCommandAnimationItem from '../container/ToyCommandAnimationItem.js';
import { EMPTY_ARRAY } from '../resource/defaults.js';
import { privateShowStatus } from '../resource/liveStreamConstants.js';

export const ToyCommandAnimationPanel = React.memo(
  ({
    itemIds = EMPTY_ARRAY,
    karaokeIds = EMPTY_ARRAY,
    isToy = false,
    status = null,
  }) => {
    const hasGoals = !!itemIds?.length;
    const hasKaraokeIds = !!karaokeIds?.length;
    const shouldStopKaraokeIfPerforming =
      [privateShowStatus.PERFORMING, privateShowStatus.PREPARING].includes(
        status
      ) && !isToy;

    if (!hasKaraokeIds || shouldStopKaraokeIfPerforming) {
      return null;
    }

    return (
      <>
        {hasGoals && (
          <>
            {itemIds.map((goalId, index) => {
              const nextIndex = index + 1;
              const nextGoalId =
                nextIndex < itemIds.length ? itemIds[nextIndex] : null;

              return (
                <ToyCommandAnimationItem
                  key={goalId}
                  goalId={goalId}
                  isToy={isToy}
                  nextGoalId={nextGoalId}
                />
              );
            })}
          </>
        )}
      </>
    );
  }
);

ToyCommandAnimationPanel.displayName = 'ToyCommandAnimationPanel';

ToyCommandAnimationPanel.propTypes = {
  itemIds: PropTypes.arrayOf(PropTypes.string),
  karaokeIds: PropTypes.arrayOf(PropTypes.string),
  isToy: PropTypes.bool,
  status: PropTypes.string,
};

export default ToyCommandAnimationPanel;
